module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_11.33ceb92d.pdf";